import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import {
  gAPI_AddOns_List,
  gAPI_Promos_List,
} from '../../../../../../../constants/APIs';


function CreateForm({
  formLabel,
  visible,
  toggle,
  submit,
  updateRatePlansData,
  propertyId,
  locale
}) {
  const [applicableAddOnsList, setApplicableOnsList] = useState([]);
  const [includedAddOnsList, setIncludedAddOnsList] = useState([]);
  const [applicablePromosList, setApplicablePromosList] = useState([]);
  const [ratePlansData, setRatePlansData] = useState(
    updateRatePlansData || {
      name: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      description: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      conditions: [
        {
          statement: 'Conditions',
          languageCode: locale,
        },
      ],
      availableAddOns: [],
      includedAddOns: [],
      promos: [],
      maxGuests: 0,
      creator: 'Admin',
      extraAdultRate: 0,
      extraChildRate: 0,
      status: 'Draft',
    }
  );

  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_AddOns_List}/?propertyId=${propertyId}&status=all&languageCode=en`,
    })
      .then(res => {
        setApplicableOnsList(
          res.data.addOns.map(plan => ({
            id: plan.id,
            name: plan.name,
            checked: false,
          }))
        );
        setIncludedAddOnsList(
          res.data.addOns.map(plan => ({
            id: plan.id,
            name: plan.name,
            checked: false,
          }))
        );
      })
      .catch(err => console.log('err', err));
  }, [propertyId]);

  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Promos_List}/?propertyId=${propertyId}&status=all&languageCode=en`,
    })
      .then(res => {
        setApplicablePromosList(
          res.data.promos.map(prom => ({
            id: prom.id,
            name: prom.name,
            checked: false,
          }))
        );
      })
      .catch(err => console.log('err', err));
  }, [propertyId]);

  const handleChangeArr = e => {
    const key = e.target.name;
    const value = e.target.value;
    setRatePlansData({
      ...ratePlansData,
      [key]: [
        {
          statement: value,
          languageCode: 'en',
        },
      ],
    });
  };

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex(m => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(m => m.languageCode === 'en');
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      }
      else {
        return statements[index].statement;
      }
    }
  }

  const handleChangeNameArr = e => {
    if (ratePlansData.name.length > 0) {
      const index = ratePlansData.name.findIndex(m => m.languageCode === locale);
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        }
        setRatePlansData({
          ...ratePlansData,
          name: [...ratePlansData.name, newStatement]
        });
      }
      else {
        let newArr = [...ratePlansData.name];
        newArr[index].statement = e.target.value
        setRatePlansData({
          ...ratePlansData,
          name: newArr
        });
      }
    }
    else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      }
      setRatePlansData({
        ...ratePlansData,
        name: [...ratePlansData.name, newStatement]
      });
    }
  }


  const handleChangeDescriptionArr = e => {
    if (ratePlansData.description.length > 0) {
      const index = ratePlansData.description.findIndex(m => m.languageCode === locale);
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        }
        setRatePlansData({
          ...ratePlansData,
          description: [...ratePlansData.description, newStatement]
        });
      }
      else {
        let newArr = [...ratePlansData.description];
        newArr[index].statement = e.target.value
        setRatePlansData({
          ...ratePlansData,
          description: newArr
        });
      }
    }
    else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      }
      setRatePlansData({
        ...ratePlansData,
        description: [...ratePlansData.description, newStatement]
      });
    }
  }

  const handleChangeConditionsArr = e => {
    if (ratePlansData.conditions.length > 0) {
      const index = ratePlansData.conditions.findIndex(m => m.languageCode === locale);
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        }
        setRatePlansData({
          ...ratePlansData,
          conditions: [...ratePlansData.conditions, newStatement]
        });
      }
      else {
        let newArr = [...ratePlansData.conditions];
        newArr[index].statement = e.target.value
        setRatePlansData({
          ...ratePlansData,
          conditions: newArr
        });
      }
    }
    else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      }
      setRatePlansData({
        ...ratePlansData,
        conditions: [...ratePlansData.conditions, newStatement]
      });
    }
  }

  const handleChange = e => {
    setRatePlansData({
      ...ratePlansData,
      [e.target.name]: e.target.value,
    });
  };

  const handleApplicableAddOnsChange = e => {
    const values = applicableAddOnsList.map(elem => {
      if (elem.id === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setApplicableOnsList(values);
  };

  const handleIncludedAddOnsChange = e => {
    const values = includedAddOnsList.map(elem => {
      if (elem.id === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setIncludedAddOnsList(values);
  };

  const handleApplicablePromosChange = e => {
    const values = applicablePromosList.map(elem => {
      if (elem.id === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    setApplicablePromosList(values);
  };

  useEffect(() => {
    const appAddonsArr = applicableAddOnsList
      .filter(elem => elem.checked === true)
      .map(elem => ({
        id: elem.id,
      }));
    const inclAddOnsArr = includedAddOnsList
      .filter(elem => elem.checked === true)
      .map(elem => ({
        id: elem.id,
      }));
    const appPromosArr = applicablePromosList
      .filter(elem => elem.checked === true)
      .map(elem => ({
        id: elem.id,
      }));
    setRatePlansData({
      ...ratePlansData,
      availableAddOns: appAddonsArr,
      includedAddOns: inclAddOnsArr,
      promos: appPromosArr,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicableAddOnsList, includedAddOnsList, applicablePromosList]);

  const handleSubmit = () => {
    submit(ratePlansData);
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div>applicableAddOnsList</div>
              <Row>
                <Colxx sm={4} className="mb-3">
                  <Label>Name</Label>
                  <Input
                    type="text"
                    value={getLocalStatement(ratePlansData.name)}
                    onChange={handleChangeNameArr}
                    name="name"
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Display Text</Label>
                  <Input
                    type="textarea"
                    value={getLocalStatement(ratePlansData.description)}
                    onChange={handleChangeDescriptionArr}
                    name="description"
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Conditions</Label>
                  <Input
                    type="textarea"
                    value={getLocalStatement(ratePlansData.conditions)}
                    name="conditions"
                    onChange={handleChangeConditionsArr}
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Cancellation Policy TODO: no change handler</Label>
                  <Input type="textarea" />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Max Guests</Label>
                  <Input
                    type="number"
                    min={0}
                    name="maxGuests"
                    value={ratePlansData.maxGuests}
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Extra Adult Rate</Label>
                  <Input
                    type="number"
                    min={0}
                    name="extraAdultRate"
                    value={ratePlansData.extraAdultRate}
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Extra Child Rate</Label>
                  <Input
                    type="number"
                    min={0}
                    name="extraChildRate"
                    value={ratePlansData.extraChildRate}
                    onChange={handleChange}
                  />
                </Colxx>
                {updateRatePlansData && (
                  <Colxx sm={4} className="mb-3">
                    <Label>Status</Label>
                    <Input
                      type="select"
                      value={ratePlansData.status}
                      name="status"
                      onChange={handleChange}
                    >
                      <option value="Draft">Draft</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </Input>
                  </Colxx>
                )}
              </Row>
              <h4>Add-on's & Promos</h4>
              <Row>
                <Colxx sm={4}>
                  <FormGroup>
                    <Label>Applicable Add-on's</Label>
                    {applicableAddOnsList.map((elem, index) => (
                      <CustomInput
                        key={index}
                        type="checkbox"
                        value={elem.id}
                        id={elem.id}
                        onChange={handleApplicableAddOnsChange}
                        checked={elem.checked}
                      >
                        {elem.name}
                      </CustomInput>
                    ))}
                  </FormGroup>
                </Colxx>
                <Colxx sm={4}>
                  <FormGroup>
                    <Label>Included Add-on's</Label>
                    {includedAddOnsList.map((elem, index) => (
                      <CustomInput
                        key={index}
                        type="checkbox"
                        value={elem.id}
                        id={elem.id}
                        onChange={handleIncludedAddOnsChange}
                        checked={elem.checked}
                      >
                        {elem.name}
                      </CustomInput>
                    ))}
                  </FormGroup>
                </Colxx>
                <Colxx sm={4}>
                  <FormGroup>
                    <Label>Applicable Promos</Label>
                    {applicablePromosList.map((elem, index) => (
                      <CustomInput
                        key={index}
                        type="checkbox"
                        value={elem.id}
                        id={elem.id}
                        onChange={handleApplicablePromosChange}
                        checked={elem.checked}
                      >
                        {elem.name}
                      </CustomInput>
                    ))}
                  </FormGroup>
                </Colxx>
              </Row>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps, {})(CreateForm));

CreateForm.propTypes = {
  formLabel: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  updateRatePlansData: PropTypes.shape({
    name: PropTypes.array.isRequired,
    description: PropTypes.array.isRequired,
    conditions: PropTypes.array.isRequired,
    status: PropTypes.string.isRequired,
  }),
};
